import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IRole } from "../../utils/types/models";

export default createEntityReducer<IRole>(Endpoint.Roles, Endpoint.RolesList);
